import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import getConditionById from 'editor/src/store/design/selector/getConditionById';
import { updateConditionOptionLabelAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import applyTextVariantsForConditionOperation from './applyTextVariantsForConditionOperation';
import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const updateConditionOptionLabelOperation =
  (address: ConditionAddress, optionId: string, label: string) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    batch(() => {
      dispatch(updateConditionOptionLabelAction({ address, optionId, label }));

      // A label-mode text's content IS the active option's label (see
      // resolveTextVariant), so renaming the ACTIVE option changes what those
      // texts should show — unlike per-option text, whose values never depend
      // on a label and are correctly left untouched by a rename. Re-running
      // the same swap the active-option change itself uses picks up exactly
      // the label-mode texts and leaves everything else a no-op.
      const condition = getConditionById(getState(), address.conditionId)?.condition;
      if (condition?.activeOptionId === optionId) {
        const recomputed = dispatch(applyTextVariantsForConditionOperation(address.conditionId, optionId));
        if (!recomputed.has(address.spreadIndex)) {
          dispatch(updateHiddenElementsOperation(address.spreadIndex));
        }
      }
    });
  };

export default updateConditionOptionLabelOperation;
